export default __webpack_public_path__ + "static/media/shopDefault-2x.0f7dc8ce.jpg";